<template>
    <transition name="modal-fade">
        <div class="modal" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body ">
                        <div class="form-row"> 
                            <label for="name" required>{{ $t('name') }}</label>
                            <input v-model="data.name" type="text" class="form-control" id="name" :placeholder="$t('enterName')">
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="close" data-dismiss="modal" >
                            {{ $t('close') }}
                        </button>
                        <button type="button" class="btn btn-primary float-right" @click="onSubmit">{{ $t('create') }}</button>
                    </div>
                </div>
            </div>
        </div>
    </transition>

</template>

<script>
import ImageApi from '../../../api/server/image';

export default {
    methods: {
        async onSubmit() {
            let imagetable = await ImageApi.imageTableCreate(this.data);
            this.$router.push({ name: 'imagetabledetail', params: { id: imagetable.id } });
        },
        close() {
            this.$parent.isAddImageVisible = false;
        }
    },
    data() {
        return {
            data: {
                name: "",
                projection: 'GEOGCS["WGS 84", DATUM["World Geodetic System 1984", SPHEROID["WGS 84", 6378137.0, 298.257223563, AUTHORITY["EPSG","7030"]], AUTHORITY["EPSG","6326"]], PRIMEM["Greenwich", 0.0, AUTHORITY["EPSG","8901"]], UNIT["degree", 0.017453292519943295], AXIS["Geodetic longitude", EAST], AXIS["Geodetic latitude", NORTH], AUTHORITY["EPSG","4326"]]'
            }
        }
    }
};
</script>